<template lang="pug">
.pm-sr-team
    .pm-sr-team-res
        .pm-sr-team-res-pos
            span.fi-per__label {{ $t('Position') }}
            span.pm-sr-team-res-pos-num
                span.pm-sr-team-res-pos-num__value {{ this.$props.position }}
                span.pm-sr-team-res-pos-num__ordinal {{ this.ordinal }}
        .pm-sr-team-res-streak
            span.fi-per__label {{ $t('Streak') }}
            .pm-sr-team-res-streak-list
                .ge__streak(
                    v-for="match in reversedLastMatches"
                    v-text="(match.result === 'V') ? $t('W') : $t('L')"
                    :class="(match.result === 'V') ? 'ge__streak--win' : 'ge__streak--lose'"
                )
    img.pm-sr-team__shield(:src="this.$props.teamImage")
    .pm-sr-team-table
        StandingsTable(
            v-show = "this.$props.teamStandings.length"
            :standings = "this.$props.teamStandings"
            :pre_match="true"
            :sel_team="this.$props.teamId"
        )

</template>
<script>
import StandingsTable from "@/components/subcomponents/StandingsTable.vue";


export default {

    props: {
        position: Number,
        lastMatches: Array,
        teamImage: String,
        teamStandings: Array,
        teamId: Number,
    },
    computed: {
        reversedLastMatches() {
            return this.lastMatches.slice().reverse();
        },
        ordinal() {
            if (this.$store.state.general.lang == 'en') {
                if (this.position > 3 && this.position < 21) return 'th';
                switch (this.position % 10) {
                    case 1: return "st";
                    case 2: return "nd";
                    case 3: return "rd";
                    default: return "th";
                }
            }
            return '°'
        }
    },
    components: {
        StandingsTable
    }
};
</script>